"use strict";

import angular from "angular";

import template from "./table-customization.component.html";
import "./themes/table-customization.component.scss";
import "./themes/table-customization-dark.component.scss";

export class TableCustomizationComponent {
    constructor($state, $scope) {
        this.$state = $state;
        this.$scope = $scope;

        this.bodyTable = [];
        this.body = [];
        this.selectedAllSeries = false;
    }

    $onInit() {
        this.onInitView();
        this.$scope.$watch(this.bodyTable, (oldValue, newValue) => {
            this.body = this.bodyTable;
        });
    }

    onInitView() {
        this.tableController = {
            indicators: [
                {
                    title: "Nome",
                    filterName: true,
                    selectAll: this.selectAll
                },
                {
                    title: "Fonte"
                },
                {
                    title: "Acessível por"
                },
                {
                    title: "Análise"
                },
                {
                    title: "Unidade"
                },
                {
                    title: "Ações"
                }
            ],
            graphics: [
                {
                    title: "Nome",
                    filterName: true,
                    selectAll: this.selectAll
                },
                {
                    title: "Fonte"
                },
                {
                    title: "Acessível por"
                },
                {
                    title: "Nº Indicadores"
                },
                {
                    title: "Tipo",
                    filterType: false
                },
                {
                    title: "Ações"
                }
            ]
        };
    }

    /**
     * @public
     * Filtrar os dados da tabela
     */

    onFilterSelect = (type = "A-z") => {
        switch (type) {
            case "A-z":
                this.bodyTable.sort((a, b) =>
                    a.columnOne
                        .replace("(%) ", "")
                        .localeCompare(b.columnOne.replace("(%) ", ""))
                );
                break;
            case "Z-a":
                this.bodyTable.sort((a, b) =>
                    b.columnOne
                        .replace("(%) ", "")
                        .localeCompare(a.columnOne.replace("(%) ", ""))
                );
                break;
            case "createdAt":
                this.bodyTable.sort(
                    (a, b) => new Date(b.date) - new Date(a.date)
                );

                break;
        }
    };
    /**
     * @public
     * verifucar se todos estão selecionados ou não
     */
    verifyChecked = () => {
        const selecteds = this.bodyTable.filter((s) => s.selected);
        this.selectedAllSeries =
            selecteds.length === this.bodyTable.length ? true : false;

        this.selectedsIds = this.bodyTable
            .filter((fs) => fs.selected)
            .map((s) => s.document._id);
    };

    /**
     * @public
     * Selecionar todas as series
     */
    selectAll = () => {
        this.bodyTable = this.bodyTable.map((t) => {
            return {
                ...t,
                selected: !this.selectedAllSeries ? true : false
            };
        });

        this.selectedsIds = this.bodyTable
            .filter((fs) => fs.selected)
            .map((s) => s.document._id);
    };
}

TableCustomizationComponent.$inject = ["$state", "$scope"];

const name = "tableCustomizationComponent";
const def = {
    bindings: {
        data: "<",
        route: "<",
        bodyTable: "<",
        selectedsIds: "=",
        onDelete: "&",
        onUpdate: "&",
        hasPermissionCompanyModel: "<"
    },
    
    controller: TableCustomizationComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
